import {ReactComponent as VeryDissatisfiedIcon} from '../../../../../../../assets/images/very_dissatisfied.svg';
import {ReactComponent as DissatisfiedIcon} from '../../../../../../../assets/images/dissatisfied.svg';
import {ReactComponent as SlightlyDissatisfiedIcon} from '../../../../../../../assets/images/slightly_dissatisfied.svg';
import {ReactComponent as NeutralIcon} from '../../../../../../../assets/images/neutral.svg';
import {ReactComponent as SlightlySatisfiedIcon} from '../../../../../../../assets/images/slightly_satisfied.svg';
import {ReactComponent as SatisfiedIcon} from '../../../../../../../assets/images/satisfied.svg';
import {ReactComponent as VerySatisfiedIcon} from '../../../../../../../assets/images/very_satisfied.svg';

export const getEmployeeSatisfactionIcon = (value: string) => {
  switch (value) {
    case '0':
      return <VeryDissatisfiedIcon className="icon"/>;
    case '1':
      return <DissatisfiedIcon className="icon"/>;
    case '2':
      return <SlightlyDissatisfiedIcon className="icon"/>;
    case '3':
      return <NeutralIcon className="icon"/>;
    case '4':
      return <SlightlySatisfiedIcon className="icon"/>;
    case '5':
      return <SatisfiedIcon className="icon"/>;
    case '6':
      return <VerySatisfiedIcon className="icon"/>;
    default:
      return null;
  }
};
